import React from "react";
import { Link } from "react-router-dom";
import evChargingStation from '../../../assets/img/backgrounds/ev-charging-station.jpg';
import { SplideSlide } from "@splidejs/react-splide";

const EventCard = ({ event, buttonText, onSelect}) => {

    const startDate = new Date(event.start_at);
    const endDate = new Date(event.end_at); 
    const year = startDate.getFullYear();

    const isPast = endDate < new Date();
    const isDisabled = isPast;

    const cardStyle = isDisabled ? {
        opacity: 0.6,
        filter: 'grayscale(80%)',
        pointerEvents: 'none',
    } : {};

    const handleSelect = () => {
        if (!isDisabled) {
            onSelect(event);
        }
    };

    return (
        <SplideSlide>
            <article 
                className={`card border-0 bg-none h-100 ${isDisabled ? 'event-not-live' : ''}`}
                style={cardStyle} // Apply conditional styles
            >
                <div className="px-3 px-xl-4 py-3 rounded-top-4 bg-primary">
                    <h5 className="text-motability-white mb-0">
                        {event.name}
                    </h5>
                </div>

                <div className="ratio ratio-16x9">
                    <img
                        src={event.banner_url}
                        alt={event.name || "Event banner"} // Added fallback alt text
                        className="img-fluid object-fit-cover object-position-center"
                        fetchPriority="low"
                        loading="lazy"
                        decoding="async"
                    />
                </div>

                <div className="p-4 rounded-bottom-4 bg-motability-white">
                    <div className="card-date d-flex align-items-center gap-12 mb-3">
                        <i className="icon-calendar text-primary" aria-hidden="true"></i>
                        <p className="mb-0">{startDate.getDate()} and {endDate.getDate()} {startDate.toLocaleString('default', { month: 'long' })} {year}</p>
                    </div>

                    <div className="card-time d-flex align-items-center gap-12 mb-4">
                        <i className="icon-clock text-primary" aria-hidden="true"></i>
                        <p className="mb-0">{startDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })} to {endDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}</p>
                    </div>

                    <button
                        type="button"
                        className="btn btn-outline-primary rounded-pill px-4"
                        onClick={handleSelect} // Use the new handler
                        disabled={isDisabled}
                        style={isDisabled ? { pointerEvents: 'auto' } : {}}
                    >
                        {buttonText}
                    </button>
                </div>
            </article>
        </SplideSlide>
    );
};

export default EventCard; 